// Modules
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from './modules/shared/shared.module';
// import { RouterModule } from '@angular/router';

// Services, Guards and Interceptors
import { SidenavService } from './services/sidenav.service'
import { ApiV2Service } from './services/api-v2.service';
import { AuthService } from './services/auth.service';
import { UrlParamsService } from './services/url-params.service';
import { AuthGuard } from './guards/auth.guard';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { PushNotificationsService } from './services/push-notifications.service';

// Components
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { LeftMenuComponent } from './components/left-menu/left-menu.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { FiltersComponent } from './components/filters/filters.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { AdminGuard } from './guards/admin.guard';

/*language setting*/
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
//firebase
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { environment } from 'src/environments/environment';


@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: 'es',
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient],
      }
    }),
    SharedModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule
  ],
  declarations: [
    AppComponent,
    HeaderComponent,
    LeftMenuComponent,
    PageNotFoundComponent,
    FiltersComponent,
    BreadcrumbComponent
  ],
  exports: [
    // RouterModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    AuthService,
    ApiV2Service,
    SidenavService,
    UrlParamsService,
    AuthGuard,
    AdminGuard,
    PushNotificationsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
